export default __webpack_public_path__ + "static/media/Rubik-ExtraBold.303f9292.woff2";